import './App.css';
import Tabbing from './Tabbing';

function App() {
  return (
    <div className='ContainerHolder'>
        <h2 className='text-center  head'>Personal Details</h2>
        <div className=' '>
          <Tabbing/>
        </div>
    </div>
  );
}

export default App;
